import React, { useEffect, useState } from "react";
import styles from "./Business.module.scss";
import { ReactComponent as CloseIcon } from "../../../assets/images/Icons/closenew.svg";
import OutlineTextInput from "../../../components/input/OutlineTextInput";
import { Divider } from "antd";
import client from "../../../api/client";
import { useDispatch, useSelector } from "react-redux";
import {
  getMccsAction,
  getSubsidiaryGroupsAction,
} from "../../../redux/actions/appSettings/appSettings";
import {
  closeLoader,
  openLoader,
} from "../../../redux/actions/loader/loaderActions";
import report from "../../../api/report";

function UpdateDetailModal({ closeModal, fieldName, currentValue, id }: any) {
  const [active, setActive] = useState(false);
  const dispatch = useDispatch();
  const { mccs, subsidiaryGroups, subsidiaryStatuses } = useSelector(
    (state) => state.appSettingsReducer
  );
  function closeModalSingle(message?: string, err?: string) {
    closeModal(message, err);
  }

  const [inputs, setInputs] = React.useState<any>({
    value: currentValue,
  });

  const updateProps = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    const inputName = event.target.name;
    setInputs({
      ...inputs,
      value: newValue,
    });
  };

  const options = (() => {
    let value;
    switch (fieldName) {
      case "subsidiaryGroupId":
        value = subsidiaryGroups;
        break;
      case "status":
        value = subsidiaryStatuses;
        break;
      default:
        value = mccs;
        break;
    }
    console.log(value);
    return value;
  })();

  const mapMccs = (mccs: any[]) => {
    const dd: any[] = [];
    mccs.map((x) => {
      dd.push({ value: x.id, name: `${x.mcc} - ${x.description}` });
    });
    dispatch(getMccsAction(dd));
    // setOptions([...dd]);
  };

  const mapSubsidiaryGroups = (mccs: any[]) => {
    const dd: any[] = [];
    mccs.map((x) => {
      dd.push({ value: x.id, name: `${x.name}` });
    });
    dispatch(getSubsidiaryGroupsAction(dd));
    // setOptions([...dd]);
  };
  const getMccs = () => {
    if (mccs.length < 1) {
      dispatch(openLoader());
      client
        .get(`/mcc/all`)
        .then((data: any) => {
          mapMccs(data?.data?.merchantCategoryCodes ?? []);
        })
        .catch((err: any) => {})
        .finally(() => {
          dispatch(closeLoader());
        });
    }
  };

  const getSubsidiayGroups = () => {
    if (mccs.length < 1) {
      dispatch(openLoader());
      report
        .getSubsidiaryGroups()
        .then((res: any) => {
          mapSubsidiaryGroups(res?.data?.data ?? []);
        })
        .catch((err: any) => {})
        .finally(() => {
          dispatch(closeLoader());
        });
    }
  };
  const handleSubmit = (e: React.SyntheticEvent) => {
    e.preventDefault();
    dispatch(openLoader());

    setInputs({ value: "" });
    client
      .post(`subsidiary/update`, {
        subsidiaryId: id,
        [fieldName]: inputs.value,
      })
      .then((data: any) => {
        dispatch(closeLoader());
        closeModalSingle(
          data?.data?.message ?? "Merchant information updated successfully",
          ""
        );
      })
      .catch((err: any) => {
        dispatch(closeLoader());
        closeModalSingle(
          "",
          err.response?.data?.message ?? "Unable to update merchant information"
        );
      });
  };

  useEffect(() => {
    switch (fieldName) {
      case "subsidiaryGroupId":
        getSubsidiayGroups();
        break;
      case "status":
        break;
      case "mccid":
      default:
        getMccs();
        break;
    }
  }, []);
  const disabledFunction = () => {
    if (inputs.value === "" || options.length < 1) {
      return true;
    } else {
      return false;
    }
  };
  const getModalTitle = () => {
    switch (fieldName) {
      case "subsidiaryGroupId":
        return "Subsidiary Group";
      case "status":
        return "Update Merchant Status";
      case "mccid":
      default:
        return "Update Merchant MCC";
    }
  };
  return (
    <div className={styles.modalwrapper}>
      <div className={styles.modalhead}>
        <h3 className={styles.modalheadh3}>{getModalTitle()}</h3>
        <CloseIcon onClick={() => closeModal()} style={{ cursor: "pointer" }} />
      </div>
      <Divider style={{ margin: 0, padding: 0 }} />
      <div className={styles.modalcontent}>
        <div className={styles.input}>
          <OutlineTextInput
            handleChange={updateProps}
            inputName={fieldName}
            inputLabel={fieldName}
            inputValue={inputs.value}
            inputSelect
            inputOption={options}
            style={{ width: "100%" }}
          />
        </div>
        <Divider style={{ margin: 0, padding: 0 }} />

        <div className={styles.modalFooter}>
          <button className={styles.cancel} onClick={() => closeModal()}>
            Cancel
          </button>
          <button
            disabled={disabledFunction()}
            onClick={handleSubmit}
            className={styles.fund}
          >
            Update
          </button>
        </div>
      </div>
    </div>
  );
}

export default UpdateDetailModal;
